class SplitSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.split-slideshow__slide'));
    this.dots = Array.from(this.querySelectorAll('.split-slideshow__dot'));
    this.prev = this.querySelector('.split-slideshow__arrow--prev');
    this.next = this.querySelector('.split-slideshow__arrow--next');
    if (this.slides.length < 2) return;

    this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;
    this.autoplay = this.dataset.autoplay !== 'false';
    this.interval = Math.max(1000, parseInt(this.dataset.interval || '6', 10) * 1000);
    this.busy = false;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i, true)));
    this.prev?.addEventListener('click', () => this.goTo(this.index - 1, true));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1, true));

    // Add is-ready after first paint so the initial slide doesn't animate in
    requestAnimationFrame(() => this.classList.add('is-ready'));

    if (this.autoplay) this.start();
  }

  goTo(i, userAction) {
    if (this.busy) return;
    const len = this.slides.length;
    const newIdx = ((i % len) + len) % len;
    if (newIdx === this.index) return;

    this.busy = true;
    const outgoing = this.slides[this.index];
    const incoming = this.slides[newIdx];

    this.index = newIdx;
    this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === newIdx));

    // Outgoing: animate left out
    outgoing.classList.add('is-leaving');
    outgoing.classList.remove('is-active');

    // Incoming: animate in from right
    incoming.classList.add('is-active');

    // Cleanup after outgoing animation ends
    const onEnd = () => {
      outgoing.classList.remove('is-leaving');
      outgoing.removeEventListener('animationend', onEnd);
      this.busy = false;
    };
    outgoing.addEventListener('animationend', onEnd);

    if (userAction && this.autoplay) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (!this.autoplay) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('split-slideshow')) {
  customElements.define('split-slideshow', SplitSlideshow);
}
